<section class="solaranlage-wrapper" [class.internal]="internalPortal" [class.loading]="loading" #devices [formGroup]="form">
  <h2 [innerHTML]="textkeyPrefix + '.balkon.headline' | translate"></h2>

  <div class="flip-container flip-horizontal" [class.open]="toggle.compare" #devices [style.height.px]="minHeightCompare?? 'auto'">
    <div class="flipper">
      <div class="card front" #frontCardCompare>
        <div class="configuration-selection grid-x align-center">
          @for(config of buttonsTypes; track config) {
            <div class="cell small-6 medium-4">
              <button [tabindex]="toggle.compare? '-1' : '0'" class="button tab-nav" (click)="setSelection(config)" [class.primary]="currentConfiguration.startsWith(config.replace('_batterie', ''))">
                {{ textkeyPrefix + '.anlage.label.' + config.replace('_batterie', '')  | translate }}
                <small [innerHTML]="textkeyPrefix + '.anlage.label.' + config.replace('_batterie', '') + '.beschreibung' | translate"></small>
              </button>
            </div>
          }
        </div>
        <div class="callout toggle-wrapper">
          <div class="grid-x grid-margin-x">
            @if (currentConfiguration !== 'klein') {
              <div class="cell small-12 medium-shrink">
                <div class="toggle invert">
                  <input type="checkbox" id="batteriespeicher" formControlName="batteriespeicher" [tabindex]="toggle.compare? '-1' : '0'">
                  <label for="batteriespeicher" [innerHTML]="textkeyPrefix + '.anlage.toggle.batteriespeicher' | translate"></label>
                </div>
              </div>
            }
            <div class="cell small-12 medium-shrink">
              <div class="toggle invert">
                <input type="checkbox" id="verschattung" formControlName="verschattung" [tabindex]="toggle.compare? '-1' : '0'">
                <label for="verschattung" [innerHTML]="textkeyPrefix + '.anlage.toggle.verschattung' | translate"></label>
              </div>
              <button class="help-button" [tabindex]="toggle.compare? '-1' : '0'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggle.shadedHelp = !toggle.shadedHelp"><i class="icon-help-circle"></i></button>
            </div>
          </div>
        </div>
        @if(toggle.shadedHelp) {
          <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="anlage.verschattung" (close)="toggle.shadedHelp = !toggle.shadedHelp"></app-photovoltaikcheck-ergebnis-help>
        }

        <div class="callout">
          <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
              <p [innerHTML]="textkeyPrefix + '.fazit.balkon.' + currentConfiguration.replace('_batterie', '') | translate: placeholder"></p>
              @if(anfrage.userInput.aufstellort === 'freiflaeche') {
                <p [innerHTML]="textkeyPrefix + '.fazit.balkon.freiflaeche' | translate: placeholder"></p>
              }
              @if(anfrage.userInput.verschattung) {
                <p [innerHTML]="textkeyPrefix + '.fazit.balkon.verschattet' | translate: placeholder"></p>
              }
            </div>
            <div class="cell small-12 medium-6">
              <div class="grid-x">
                <div class="cell medium-6" [class.small-6]="currentConfiguration.endsWith('batterie')">
                  <div class="attribute">
                    <app-advisor-image
                      [path]="'/pvc/balkonkraftwerk' + (anfrage.userInput.verschattung? '_verschattet' : '') + '.svg'"
                    ></app-advisor-image>
                    <strong [innerHTML]="textkeyPrefix + '.balkonkraftwerk.label' | translate"></strong>
                    <span>
                      {{ placeholder['leistung'] }}
                      <small [innerHTML]="'unit.w' | translate"></small>
                    </span>
                  </div>
                </div>
                <div class="cell small-6">
                  @if(currentConfiguration.endsWith('batterie')) {
                    <div class="attribute">
                      <app-advisor-image [path]="'/pvc/batteriespeicher.svg'"></app-advisor-image>
                      <strong [innerHTML]="textkeyPrefix + '.batteriespeicher.label' | translate"></strong>
                      <span>
                        {{ placeholder['batteriespeicher_kapazitaet'] }}
                        <small [innerHTML]="'unit.kwh' | translate"></small>
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="grid-x grid-padding-x kpi-wrapper">
            @for(kpi of ['einsparung', 'amortisation', 'co2']; track kpi) {
              <div class="cell small-12 medium-4">
                <div class="kpi">
                  <span [innerHTML]="textkeyPrefix + '.kpi.' + kpi | translate: placeholder"></span>
                  <small [innerHTML]="textkeyPrefix + '.kpi.' + kpi + '.zusatz' | translate: placeholder"></small>
                </div>
              </div>
            }
          </div>
          <div class="grid-x grid-padding-x">
            <div class="cell small-12">
              <button class="button primary hollow inline-arrow-right" [tabindex]="toggle.compare? '-1' : '0'" (click)="flipCompare()" [innerHTML]="textkeyPrefix + 'balkon.vergleich.button' | translate"></button>
            </div>
          </div>
        </div>
      </div>
      <div class="card back" #backCardCompare>
        <div class="text-right">
          <button class="button round primary small compare-close" [tabindex]="!toggle.compare? '-1' : '0'" (click)="flipCompare()" >
            <i class="icon-x" [title]="textkeyPrefix + '.vergleich.close' | translate"></i>
            {{ textkeyPrefix + '.vergleich.close' | translate }}
          </button>

          <div class="scroll-table-wrapper">
            <table class="compare">
              <thead>
              <tr>
                <td></td>
                @for(config of types; track config) {
                  <th [class.active]="config === currentConfiguration">
                    {{ textkeyPrefix + '.anlage.label.' + config.replace('_batterie', '') | translate }}
                    <small [innerHTML]="textkeyPrefix + '.anlage.vergleich.label.' + config + '.beschreibung' | translate"></small>
                  </th>
                }
              </tr>
              </thead>
              <tbody>
              <tr class="highlight">
                <th [innerHTML]="textkeyPrefix + '.balkonkraftwerk.label' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['leistung'] }}
                    <small [innerHTML]="'unit.w' | translate"></small>
                  </td>
                }
              </tr>
              <tr>
                <th [innerHTML]="textkeyPrefix + '.batteriespeicher.label' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['batteriespeicher_kapazitaet_plain'] > 0 ?result.result.placeholder[config]['batteriespeicher_kapazitaet'] : '-' }}
                    <small [innerHTML]="'unit.kwh' | translate"></small>
                  </td>
                }
              </tr>
              <tr>
                <th [innerHTML]="textkeyPrefix + '.vergleich.flaeche' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['flaeche'] }}
                    <small [innerHTML]="'unit.m2' | translate"></small>
                  </td>
                }
              </tr>
              <tr class="highlight">
                <th [innerHTML]="textkeyPrefix + '.vergleich.ersparnis' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['einsparung_jaehrlich'] ?? '-' }}
                    <small>€</small>
                  </td>
                }
              </tr>
              <tr>
                <th [innerHTML]="textkeyPrefix + '.vergleich.amortisation' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['amortisation_jahr'] ?? '-' }}
                    <small [innerHTML]="'unit.jahre' | translate"></small>
                  </td>
                }
              </tr>
              <tr class="highlight">
                <th [innerHTML]="textkeyPrefix + '.klima.balkon.10jahre' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['co2_10jahre'] ?? '-' }}
                    <small>kg</small>
                  </td>
                }
              </tr>
              <tr class="highlight">
                <th [innerHTML]="textkeyPrefix + '.balkon.daten.solarstrom' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ result.result.placeholder[config]['autarkiegrad'] ?? '-' }}
                    <small>%</small>
                  </td>
                }
              </tr>
              <tr class="divider">
                <td [attr.colspan]="types.length + 1"></td>
              </tr>
              <tr class="costs">
                <th [innerHTML]="textkeyPrefix + '.finanzierung.balkon.invest' | translate"></th>
                @for(config of types; track config) {
                  <td>
                    {{ configurations[config].config.finanzierung.investitionskosten_gesamt | number: '1.0-0' }}
                    <small>€</small>
                  </td>
                }
              </tr>
              </tbody>
            </table>
            <div class="cell small-12 medium-text-right">
              <small class="hint" [innerHTML]="textkeyPrefix + '.klima.hint' | translate: placeholder"></small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section>
  <h2 [innerHTML]="textkeyPrefix + '.finanzierung.balkon.headline' | translate"></h2>

  <p [innerHTML]="textkeyPrefix + '.finanzierung.balkon.teaser' | translate"></p>

  <div class="finance-wrapper" [class.loading]="loading">
    <div class="invest-header">
      <h3 [innerHTML]="textkeyPrefix + '.finanzierung.balkon.invest' | translate"></h3>
      <div>
        <span class="amount">{{ configurations[currentConfiguration].config.finanzierung.investitionskosten_gesamt | number: '1.0-0' }} €</span>
        <button class="help-button" [attr.aria-label]="'arialabel.toggle.help' | translate" [title]="textkeyPrefix + '.hilfe' | translate" (click)="toggle.investHelp = !toggle.investHelp"><i  class="icon-help-circle"></i></button>
      </div>
    </div>
    @if (toggle.investHelp) {
      <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="finanzierung.balkon.invest" (close)="toggle.investHelp = !toggle.investHelp"></app-photovoltaikcheck-ergebnis-help>
    }
    <div class="invest-content">
      <div class="grid-x grid-padding-x">
        @if (configurations[currentConfiguration].config.finanzierung?.foerderung_zuschuss?.summe > 0) {
          @for(zuschuss of configurations[currentConfiguration].config.finanzierung.foerderung_zuschuss.details; track zuschuss.name) {
            <div class="cell auto">
              {{ textkeyPrefix + '.finanzierung.zuschuss' | translate }}
              <br>
              {{ zuschuss.name }}
            </div>
            <div class="cell auto text-right">
              {{ zuschuss.wert | number: '1.0-0' }} €
            </div>
          }
        }
        @else {
          <div class="cell auto">{{ textkeyPrefix + '.finanzierung.keinzuschuss' | translate }}</div>
        }
      </div>
      @if (configurations[currentConfiguration].config.finanzierung?.foerderung_zuschuss?.summe > 0) {
        <hr>
        <div class="grid-x grid-padding-x">
          <div class="cell auto">
            {{ textkeyPrefix + '.finanzierung.investition' | translate }}
          </div>
          <div class="cell auto text-right">
            {{ (configurations[currentConfiguration].config.finanzierung.investitionskosten_gesamt - configurations[currentConfiguration].config.finanzierung.foerderung_zuschuss.summe) | number: '1.0-0' }} €
          </div>
        </div>
      }
    </div>
    <div class="caption">
      <p [innerHTML]="textkeyPrefix + '.finanzierung.balkon.fazit' | translate: placeholder"></p>
    </div>
  </div>
</section>


<section class="economics">
  <h2 [innerHTML]="textkeyPrefix + '.balkon.daten.headline' | translate"></h2>

  <div class="flip-container flip-horizontal" [class.open]="toggle.price" [style.min-height.px]="minHeightPrice">
    <div class="flipper">
      <div class="card front" #frontCardPrice [attr.aria-hidden]="!toggle.price">
        <table class="data">
          <tbody>
          <tr>
            <th>
              {{ textkeyPrefix + '.balkon.daten.ersparnis' | translate }}
              <button class="edit-button" [tabindex]="toggle.price? '-1' : '0'" role="button" (click)="flipPrice()">
                <i class="icon-edit-3"></i>
                {{ textkeyPrefix + '.wirtschaftlichkeit.table.einsparung.strompreis.edit' | translate }}
              </button>
            </th>
            <td>{{ placeholder['einsparung_jaehrlich'] }} €</td>
          </tr>
          <tr>
            <th [innerHTML]="textkeyPrefix + '.balkon.daten.erzeugung' | translate"></th>
            <td>{{ placeholder['ertrag'] }} {{'unit.kwh' | translate}}</td>
          </tr>
          <tr>
            <th [innerHTML]="textkeyPrefix + '.balkon.daten.strombezug' | translate"></th>
            <td>{{ placeholder['eigennutzung'] }} {{'unit.kwh' | translate}}</td>
          </tr>
          <tr>
            <th [innerHTML]="textkeyPrefix + '.balkon.daten.einspeisung' | translate"></th>
            <td>{{ placeholder['einspeisung'] }} {{'unit.kwh' | translate}}</td>
          </tr>
          <tr>
            <th [innerHTML]="textkeyPrefix + '.balkon.daten.batteriespeicher_verlust' | translate"></th>
            <td>{{ placeholder['batteriespeicher_verluste_plain']? placeholder['batteriespeicher_verluste'] : '-' }} {{'unit.kwh' | translate}}</td>
          </tr>
          <tr>
            <th [innerHTML]="textkeyPrefix + '.balkon.daten.solarstrom' | translate"></th>
            <td>{{ placeholder['autarkiegrad'] }} %</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card back" #backCardPrice [attr.aria-hidden]="toggle.price">
        <app-photovoltaikcheck-ergebnis-price
          [textkeyPrefix]="textkeyPrefix"
          [anfrage]="anfrage"
          [loading]="toggle.loading"
          [isHidden]="!toggle.price"
          (close)="flipPrice()"
          (save)="saveForm($event)"
        ></app-photovoltaikcheck-ergebnis-price>
      </div>
    </div>
  </div>
</section>

<section>
  <h2 [innerHTML]="textkeyPrefix + '.klima.balkon.headline' | translate"></h2>

  <div class="grid-x grid-margin-x">
    @for (type of ['10jahre', 'ausgleich_baeume_10jahre']; track type) {
      <div class="cell small-6">
        <div class="co2">
          <span [innerHTML]="textkeyPrefix + '.klima.balkon.' + type | translate"></span>
          <strong>
            {{ placeholder['co2_' + type] }}
            @if(type === '10jahre') {
              {{ 'unit.kg_short' | translate }}
            }
          </strong>
        </div>
      </div>
    }
    <div class="cell small-12 medium-text-right">
      <small class="hint" [innerHTML]="textkeyPrefix + '.klima.hint' | translate: placeholder"></small>
    </div>
  </div>
</section>
